import $axios from '@/core/api-config'

class PlanService {
  getCurrentPlan () {
    return $axios.get('/api/payment')
  }

  getPlans () {
    return $axios.get('/api/payment/plans')
  }

  upgradePlan ({ planId, userId }) {
    return $axios.get(`/api/payment/stripe/session/${planId}/${userId}`)
  }

  upgradeTeamPlan ({ planId, userId, teamId }) {
    return $axios.get(`/api/payment/stripe/session/${planId}/${userId}?teamId=${teamId}`)
  }

  invoices () {
    return $axios.get('/api/payment/stripe/invoices')
  }

  stats () {
    return $axios.get('/api/stats')
  }

  cancelSubscription () {
    return $axios.delete('/api/payment/stripe')
  }
}

export const planService = new PlanService()
